module.exports = __webpack_public_path__ + "img/FalconEdgeFull-Black.e043f61.png";